<template>
  <div>
    <h1>Images</h1>

    <b-container fluid class="bg-dark">
      <b-row cols="1" cols-sm="2" cols-md="4" cols-lg="6">
        <b-col v-for="asset in selectedAssets" v-bind:key="asset.id">
          <div class="hoverDeleteDiv">
            <b-img-lazy thumbnail fluid :src="asset.URL" :alt="asset.title" class="my-1 myx-2"></b-img-lazy>
            <b-button variant="primary" class="hoverButton top" @click="deselect(asset)">Deselect</b-button>
          </div>
          <p class="text-light font-weight-lighter">{{asset.title}}</p>
        </b-col>
      </b-row>
    </b-container>

    <b-form-input id="searchTitleInput" v-model="searchTitle"></b-form-input>

    <b-button @click="add">Add</b-button>
    <b-container fluid class="bg-dark">
      <b-row cols="1" cols-sm="2" cols-md="4" cols-lg="6">
        <b-col v-for="asset in assetsFilteredByTitleX" v-bind:key="asset.id">
          <div class="hoverDeleteDiv">
            <b-img-lazy thumbnail fluid :src="asset.URL" :alt="asset.title" class="my-1 myx-2"></b-img-lazy>
            <b-button variant="primary" class="hoverButton top" @click="select(asset)">Select</b-button>
            <b-button variant="danger" class="hoverButton middle" @click="del(asset)">Delete</b-button>
          </div>
          <p class="text-light font-weight-lighter">{{asset.title}}</p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import asset from "../js/asset";
import fb from "../firebaseConfig";
import store from "@/store";

export default {
  data() {
    return {
      searchTitle: ""
    };
  },
  methods: {
    async add() {
      const newAsset = await asset.createRandomAsset(
        [this.user.details.uid],
        asset.AssetType.IMAGE
      );
      await newAsset.fbSave();
      newAsset.title += " - edited";
      newAsset.fbSave();
    },
    select(fbAssetRef) {
      store.dispatch("assets/select", fbAssetRef);
    },
    deselect(fbAssetRef) {
      store.dispatch("assets/deselect", fbAssetRef);
    },
    async del(fbAssetRef) {
      try {
        const fbStoreRef = fb.storage.refFromURL(fbAssetRef.URL);
        if (fbStoreRef) {
          fbStoreRef.delete();
        }
      } catch (error) {
        console.log("Didn't delete asset from file store");
      }

      fb.db
        .collection("assets")
        .doc(fbAssetRef.id)
        .delete();
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      assets: "assets/assets",
      selectedAssets: "assets/selected",
      assetsFilteredByTitle: "assets/assetsFilteredByTitle"
    }),
    assetsFilteredByTitleX() {
      return this.assetsFilteredByTitle(this.searchTitle);
    }
  }
};
</script>

<style scoped>
.hoverButton {
  position: absolute;
  display: none;
}

.top {
  top: 30pt;
  left: 50%;
  transform: translate(-50%, -50%);
}

.middle {
  top: 70pt;
  left: 50%;
  transform: translate(-50%, -50%);
}

.hoverDeleteDiv:hover .hoverButton {
  display: block;
}
</style>